// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/update_assay_data_response.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssayData } from "./assay_data_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_data } from "./assay_data_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/update_assay_data_response.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_response: GenFile = /*@__PURE__*/
  fileDesc("CkhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvdXBkYXRlX2Fzc2F5X2RhdGFfcmVzcG9uc2UucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSJ1ChdVcGRhdGVBc3NheURhdGFSZXNwb25zZRJLCgphc3NheV9kYXRhGAEgASgLMjIucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkFzc2F5RGF0YUgAiAEBQg0KC19hc3NheV9kYXRhYgZwcm90bzM", [file_quanterix_simoa_one_analysis_app_api_v1_assay_data]);

/**
 * Rpc response containing updated assay data
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataResponse
 */
export type UpdateAssayDataResponse = Message<"quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataResponse"> & {
  /**
   * Assay data to be updated
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayData assay_data = 1;
   */
  assayData?: AssayData;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.UpdateAssayDataResponse.
 * Use `create(UpdateAssayDataResponseSchema)` to create a new message.
 */
export const UpdateAssayDataResponseSchema: GenMessage<UpdateAssayDataResponse> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_update_assay_data_response, 0);

